import { createAction, props } from "@ngrx/store";
import {
  IDataPoint,
  IFilterConditions,
} from "@skills-app/models/skillStatistics";

const prefix = "[Skill Statistics API]";

export const requestGraphData = createAction(
  `${prefix} Request Graph Data`,
  props<{ filterConditions: IFilterConditions }>(),
);
export const requestGraphDataSuccess = createAction(
  `${prefix} Request Graph Data Success`,
  props<{ data: IDataPoint[] }>(),
);
